import styled from 'styled-components';
import colors from '@theme/colors';

const ButtonAsLink = styled.button`
  all: unset;
  text-decoration: underline;
  color: ${colors.LINK};
`;

export default ButtonAsLink;



// WEBPACK FOOTER //
// ./components/layout/ButtonAsLink.js